import React, { useState, useEffect, useMemo } from "react";
// import { useLocation, useHistory } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
  makeDealerOnboardStorageKey,
  loadPersistedDealerOnboard,
  savePersistedDealerOnboard,
} from "utils/persistForm";
// Safe fallback for reading navigation state without Router hooks
const getNavigationState = () => {
  if (typeof window === "undefined") return null;
  const st = window.history && window.history.state;
  return st?.usr || st?.state || null;
};

// Helper to derive dealerId from multiple sources
const getDealerId = () => {
  try {
    const st = getNavigationState();
    const fromState = st?.dealerId || st?.dealer_id || null;
    const fromQuery =
      typeof window !== "undefined"
        ? new URLSearchParams(window.location.search).get("dealerId")
        : null;
    const fromStorage =
      typeof window !== "undefined"
        ? window.localStorage.getItem("dealerId")
        : null;
    return fromState || fromQuery || fromStorage || null;
  } catch (_) {
    return null;
  }
};

// Helper: read auth token from localStorage
const getAuthToken = () => {
  try {
    if (typeof window === "undefined") return null;
    // primary key 'token', fallbacks if your app uses different keys
    return (
      window.localStorage.getItem("token") ||
      window.localStorage.getItem("authToken") ||
      window.localStorage.getItem("jwt") ||
      null
    );
  } catch (_) {
    return null;
  }
};
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
  TextField,
  Typography,
  Container,
  Grid,
  ListSubheader,
  Divider,
  Stack,
  Tooltip,
  CircularProgress,
  Stepper,
  Step,
  StepLabel,
  Autocomplete,
  Chip,
  InputAdornment,
  Alert,
  Dialog,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { PageHeader, SectionCard } from "_shared/ui";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { toastMessage } from "utils/toastMessage";
import { getDealerData, getCustomerGroupData, getParticularDealerOnboardingData, validatePanApi, validateGstApi } from "_controllers/officer";
import AccessController from "_shared/AccessController";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import { DashGridL2 } from "layouts/dash-grid";
import { DealerOnboardPreview } from "./Preview";

// Chip + hover tooltip for one onboarding stage; mirrors the styling used in
// the Actyv AI prospect table so statuses read the same everywhere.
const stageStatusKind = (status) => {
  const s = (status ?? "").toString().trim().toLowerCase();
  if (["accepted", "approved", "success", "paid", "true"].includes(s))
    return "success";
  if (["pending", "initiated", "in progress", "waiting"].includes(s))
    return "warning";
  if (["rejected", "failed", "error"].includes(s)) return "error";
  return "default";
};

const StageStatusChip = ({ label, status, message, successLabel }) => {
  const kind = stageStatusKind(status);
  const text =
    kind === "success" && successLabel
      ? successLabel
      : status && status !== "N/A"
      ? status.toString().toUpperCase()
      : "N/A";
  const chip = (
    <Chip
      size="small"
      label={`${label}: ${text}`}
      color={kind === "default" ? undefined : kind}
      variant={kind === "default" ? "outlined" : "filled"}
      sx={{ fontWeight: 600 }}
    />
  );
  return message ? (
    <Tooltip title={message} arrow>
      <span style={{ cursor: "help" }}>{chip}</span>
    </Tooltip>
  ) : (
    chip
  );
};

const initialFormData = {
  // DROPDOWNS → { id, code, label }
  customer_group: {  code: "", label: "" },
  customer_pricing_procedure: {  code: "", label: "" },
  terms_of_payment: {  code: "", label: "" },
  // incoterms: {  code: "", label: "" },

  account_assignment_group: {  code: "", label: "" },
  // reconciliation_account: {  code: "", label: "" },
  account_group: {  code: "", label: "" },
  sales_office: {  code: "", label: "" },
  distribution_channel: {  code: "", label: "" },
  // division: {  code: "", label: "" },
  state: {  code: "", label: "" },
  customer_class: {  code: "", label: "" },
  status: {  code: "", label: "" },
  price_group: {  code: "", label: "" },
  price_list: {  code: "", label: "" },

  // TEXT → { code }
  // company_code: { code: "" },
  // sales_org: { code: "" },
  with_sas: { code: "" },
  // title: { code: "" },

  dealership_name: { code: "" },
  dealership_add:{ code: "" },
  // street_house_no: { code: "" },
  care_of: { code: "" },
  // street2: { code: "" },
  // street3: { code: "" },
  // street5: { code: "" },
  region: { code: "" },
  district: { code: "" },
  // different_city: { code: "" },
  mobile_phone: { code: "" },
  // telephone: { code: "" },
  // fax: { code: "" },
  // tax_number_3: { code: "" },
  pan: { code: "" },

  customer_statistic_group: { code: "" },
  delivering_plant: { code: "" },
  rebate: { code: "" },
  // incoterms1: { code: "" },
  // customer_segment: { code: "" },
  // credit_limit: { code: "" },
  payment_terms: { code: "" },
  // delivery_priority: { code: "" },
  // tax_classification: { code: "" },
  // language: { code: "" },
  // sales_district: { code: "" },
  // sales_group: { code: "" },
  // price_list_group: { code: "" },
  // incoterm_location: { code: "" },
  // billing_block: { code: "" },
  // shipping_condition: { code: "" },
  // customer_status: { code: "" },
  // account_manager: { code: "" },
  // sales_channel: { code: "" },
  // distribution_method: { code: "" },
  gst_number: { code: "" },
  latitude: { code: "" },
  longitude: { code: "" },
  city: { code: "" },
  postal_code: { code: "" },
  // country: { code: "" },
  contact_person: { code: "" },
  phone_number: { code: "" },
  email: { code: "" },
  address: { code: "" },
  ///
  populationOfCity:{ code: "" },
  regionalOffice:{ code: "" },
  noOfYearsBusiness:{ code: "" },
  passportDetails:{ code: "" },
  fatherName:{ code: "" },
  // spouseName:{ code: "" },
  dateOfBirth:{ code: "" },
  shopStatus:{ code: "" },
  nearestJKDealer:{ code: "" },
  nearestSteelWheel:{ code: "" },
  competitionBrandShop:{ code: "" },
  commercialOfficerName:{ code: "" },
  commercialOfficerEmail:{ code: "" },
  commercialOfficerPhone:{ code: "" },
  gstCertificate:{ code: "" ,imageUrl: ""},
  panCardPhoto:{ code: "" ,imageUrl: ""},
  cibilScoreCard:{ code: "" ,imageUrl: ""},
  adhaarcardFront:{ code: "" ,imageUrl: ""},
  adhaarcardBack:{ code: "" ,imageUrl: ""},
  chequeScan:{ code: "" ,imageUrl: ""},
  addressProof:{ code: "" ,imageUrl: ""}

};

// --- Test prefill ---------------------------------------------------------
// Preselected SAP / pricing dropdowns so those sections open ready to review
// during testing. Keys are the form's internal field names; the backend maps
// them to the SAP payload (Custemergrp, Accountgrp, Distchannel, etc.).
// Dropdowns match their option by `code`, so setting only the code is enough.
// Merged over initialFormData when the form state is created (see useState
// below). All other fields (address, contact, tax, documents, geo…) are left
// blank. Remove this block and the merge to get a fully blank form.
const PREFILL_FORM_DATA = {
  // SAP & Pricing
  customer_group: { code: "02" },            // Custemergrp
  customer_pricing_procedure: { code: "7" }, // Custpriceproed
  terms_of_payment: { code: "0006" },        // Termofpayment
  account_assignment_group: { code: "DM" },  // Accassigngrp
  // Org Structure
  account_group: { code: "Z001" },           // Accountgrp
  distribution_channel: { code: "50" },      // Distchannel
  // Customer Classification
  customer_class: { code: "01" },            // Custemerclass
  status: { code: "20" },                    // Entity
  price_group: { code: "06" },               // Pricegroup
  price_list: { code: "M3" },                // Pricelist
};

// Merge PREFILL_FORM_DATA over the blank template, per field so each field's
// shape ({ code, label } / { code, imageUrl }) is preserved.
const getInitialFormData = () => ({
  ...initialFormData,
  ...Object.fromEntries(
    Object.entries(PREFILL_FORM_DATA).map(([key, val]) => [
      key,
      { ...(initialFormData[key] || {}), ...val },
    ])
  ),
});

let REACT_APP_REQUEST_ENDPOINT = process.env.REACT_APP_REQUEST_ENDPOINT;
// File validation configuration
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];
// Centralized, easily editable validation helpers and rules
// A field is "required" only if one of its rules is a required-* validator.
// Used to keep the visual asterisk in sync with what actually errors when empty.
const REQUIRED_VALIDATOR_KEYS = ["requiredText", "requiredDropdown"];
const isRequiredField = (key) =>
  (validationRules[key] || []).some((rule) =>
    REQUIRED_VALIDATOR_KEYS.some((rk) => validators[rk] === rule.fn)
  );

const validators = {
  requiredText: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    return v && String(v).trim().length > 0;
  },
  requiredDropdown: (value) => {
    if (!value) return false;
    if (typeof value === "object") {
      return (value.code && String(value.code).trim() !== "") || !!value.id;
    }
    return String(value).trim() !== "";
  },
  email: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (!v) return true; // optional unless combined with required
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v));
  },
  phone10: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (!v) return true;
    return /^\d{10}$/.test(String(v));
  },
  pin6: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (!v) return true;
    return /^\d{6}$/.test(String(v));
  },
  pan: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (!v) return true;
    return /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(String(v).toUpperCase());
  },
  gstin: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (!v) return true;
    return /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(String(v).toUpperCase());
  },
  number: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (v === undefined || v === null || v === "") return true;
    return !isNaN(Number(v));
  },
  // Passes when the value is a number of at least `min`. Emptiness is handled by
  // requiredText, so an empty value returns true here.
  amountAtLeast: (min) => (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (v === undefined || v === null || v === "") return true;
    const n = Number(String(v).replace(/[^0-9.]/g, ""));
    return Number.isFinite(n) && n >= min;
  },
};

// Business floor for the SAS amount (3 lakh).
const SAS_MIN_AMOUNT = 300000;
const formatINR = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

const validationRules = {
  // SAP & Pricing
  customer_group: [{ fn: validators.requiredDropdown, message: "Select Customer Group." }],
  customer_pricing_procedure: [{ fn: validators.requiredDropdown, message: "Select Customer Pricing Procedure." }],
  terms_of_payment: [{ fn: validators.requiredDropdown, message: "Select Terms of Payment." }],
  account_assignment_group: [{ fn: validators.requiredDropdown, message: "Select Account Assignment Group." }],
  // reconciliation_account: [{ fn: validators.requiredDropdown, message: "Select Reconciliation Account." }],

  // Org Structure
  account_group: [{ fn: validators.requiredDropdown, message: "Select Account Group." }],
  // company_code: [{ fn: validators.requiredText, message: "Enter Company Code." }],
  // sales_org: [{ fn: validators.requiredText, message: "Enter Sales Org." }],
  sales_office: [{ fn: validators.requiredDropdown, message: "Select Sales Office." }],
  distribution_channel: [{ fn: validators.requiredDropdown, message: "Select Distribution Channel." }],
  // title: [{ fn: validators.requiredText, message: "Enter Title." }],

  // Customer Classification
  state: [{ fn: validators.requiredDropdown, message: "Select State." }],
  customer_class: [{ fn: validators.requiredDropdown, message: "Select Customer Class." }],
  status: [{ fn: validators.requiredDropdown, message: "Select Entity." }],
  price_group: [{ fn: validators.requiredDropdown, message: "Select Price Group." }],
  price_list: [{ fn: validators.requiredDropdown, message: "Select Price List." }],

  // Address
  dealership_name: [{ fn: validators.requiredText, message: "Enter Dealership Name." }],
  // street_house_no: [{ fn: validators.requiredText, message: "Enter Street/House No." }],
  city: [{ fn: validators.requiredText, message: "Enter City." }],
  address: [{ fn: validators.requiredText, message: "Enter Address." }],
  region: [{ fn: validators.requiredText, message: "Enter Region." }],
  district: [{ fn: validators.requiredText, message: "Enter District." }],
  postal_code: [
    { fn: validators.requiredText, message: "Enter Postal Code." },
    { fn: validators.pin6, message: "Postal Code must be 6 digits." },
  ],

  // Contact
  contact_person: [{ fn: validators.requiredText, message: "Enter Contact Person." }],
  // phone_number: [{ fn: validators.phone10, message: "Enter 10-digit Landline/Mobile." }],
  mobile_phone: [{ fn: validators.phone10, message: "Enter 10-digit Mobile." }],
  email: [
    { fn: validators.requiredText, message: "Enter Email." },
    { fn: validators.email, message: "Enter a valid Email." },
  ],

  // Tax & Compliance
  gst_number: [
    { fn: validators.requiredText, message: "Enter GST Number." },
    { fn: validators.gstin, message: "Enter valid GST Number." },
  ],
  pan: [
    { fn: validators.requiredText, message: "Enter PAN." },
    { fn: validators.pan, message: "Enter valid PAN." },
  ],
  // SAS amount: required and must meet the business floor (it drives the payment amount).
  with_sas: [
    { fn: validators.requiredText, message: "Enter SAS amount." },
    {
      fn: validators.amountAtLeast(SAS_MIN_AMOUNT),
      message: `SAS amount must be at least ${formatINR(SAS_MIN_AMOUNT)}.`,
    },
  ],
  
  // Documents (toggle required as per business need)
  gstCertificate: [{ fn: validators.requiredText, message: "Upload GST Certificate." }],
  panCardPhoto: [{ fn: validators.requiredText, message: "Upload PAN Card." }],
  cibilScoreCard: [{ fn: validators.requiredText, message: "Upload CIBIL Score Card." }],
  adhaarcardFront: [{ fn: validators.requiredText, message: "Upload Aadhaar Front." }],
  adhaarcardBack: [{ fn: validators.requiredText, message: "Upload Aadhaar Back." }],
  chequeScan: [{ fn: validators.requiredText, message: "Upload Cheque Scan." }],
  addressProof: [{ fn: validators.requiredText, message: "Upload Residency/Address Proof." }],
};

// Fields that get an extra remote (backend) validation call on blur.
// Existence verification via a third-party API is added on the backend later.
const REMOTE_VALIDATORS = {
  pan: validatePanApi,
  gst_number: validateGstApi,
};

// Two-phase wizard config.
// Phase 1 = basic dealer/prospect details (identity, contact, address, KYC docs).
// Phase 2 = detailed business/commercial info (SAP, org, classification, commercial).
const WIZARD_STEPS = ["Basic Details", "Business & Commercial"];

// Validated fields that belong to Phase 1 — used to gate the "Next" button.
const PHASE1_VALIDATED_FIELDS = [
  // Address
  "dealership_name", "city", "address", "region", "district", "postal_code",
  // Contact
  "contact_person", "mobile_phone", "email",
  // Tax identity
  "gst_number", "pan",
  // KYC documents
  "gstCertificate", "panCardPhoto", "cibilScoreCard",
  "adhaarcardFront", "adhaarcardBack", "chequeScan", "addressProof",
];

// Static options for selects
const ACCOUNT_ASSIGNMENT_GROUP_OPTIONS = [
  { code: "domestic_revenues", name: "Domestic Revenues" },
  { code: "domestic_replacement", name: "Domestic Replacement" },
  { code: "mobility", name: "Mobility" },
  { code: "inter_comp", name: "Inter Comp" },
  { code: "other", name: "Other" },
];
const RECONCILIATION_ACCOUNT_OPTIONS = [
  { code: "advance_replacement", name: "Advance Replacement" },
  { code: "sas_deposit_replace", name: "SAS Deposit Replace" },
  { code: "customer_replace", name: "Customer Replace" },
  { code: "others", name: "Others" },
];
const PRICE_GROUP_OPTIONS = [
  { code: "dealer", name: "Dealer" },
  { code: "distributor", name: "Distributor" },
  { code: "fleet", name: "Fleet" },
  { code: "others", name: "Others" },
];
const PRICE_LIST_OPTIONS = PRICE_GROUP_OPTIONS;
const DOCUMENT_UPLOADS = [
  { key: "gstCertificate", label: "GST Certificate" },
  { key: "panCardPhoto", label: "PAN Card" },
  { key: "cibilScoreCard", label: "CIBIL Score Card" },
  { key: "adhaarcardFront", label: "Aadhaar Card Front" },
  { key: "adhaarcardBack", label: "Aadhaar Card Back" },
  { key: "chequeScan", label: "Cheque Scan" },
  { key: "addressProof", label: "Residency/Address Proof" },
];

// Helper to detect if a string is a URL
const isHttpUrl = (value) => {
  if (!value || typeof value !== "string") return false;
  return /^https?:\/\//i.test(value);
};

const brandData = {
  "Tyre-Group-1": ["SW", "AW"],
  "Tyre-Group-2": ["12", "13"],
};

// Select that emits { id, code, label }, selects by _id (for master data)
const SelectField = ({
  label,
  fieldKey,
  options = [],
  value,
  onChange,
  required = false,
  error = false,
  errorMessage = "",
}) => (
  <FormControl fullWidth margin="normal" size="small" required={required} error={error}>
    <InputLabel required={required}>{label}</InputLabel>
    <Select
      value={value?.id || ""}
      label={label}
      onChange={(e) => {
        const opt = options?.find(
          (o) => String(o._id) === String(e.target.value)
        );
        onChange(
          fieldKey,
          opt
            ? {
                id: opt._id,
                code: opt.code || "",
                label: opt.description || opt.name || "",
              }
            : {  code: "", label: "" }
        );
      }}
    >
      {options?.map((item) => (
        <MenuItem key={item._id || item.code} value={item._id || ""}>
          {item.description || item.name || ""}{" "}
          {item.code ? `(${item.code})` : ""}
        </MenuItem>
      ))}
    </Select>
    {error && errorMessage ? <FormHelperText>{errorMessage}</FormHelperText> : null}
  </FormControl>
);

// Select that works with SAP data format { code, name }
const SapSelectField = ({
  label,
  fieldKey,
  options = [],
  value,
  onChange,
  required = false,
  disabled = false,
  error = false,
  errorMessage = "",
}) => {
  // Searchable dropdown: match the currently-selected option by its code.
  const selected =
    (options || []).find((o) => String(o.code) === String(value?.code)) || null;
  const optionLabel = (opt) =>
    opt?.name ? `${opt.name}${opt.code ? ` (${opt.code})` : ""}` : "";
  return (
    <Autocomplete
      fullWidth
      size="small"
      disabled={disabled}
      options={options || []}
      value={selected}
      getOptionLabel={optionLabel}
      isOptionEqualToValue={(opt, val) => String(opt?.code) === String(val?.code)}
      onChange={(_e, opt) =>
        onChange(
          fieldKey,
          // SAP fields don't have ObjectId, so send only { code, label }
          opt
            ? { code: opt.code || "", label: opt.name || "" }
            : { code: "", label: "" }
        )
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          margin="normal"
          error={error}
          helperText={error && errorMessage ? errorMessage : undefined}
        />
      )}
    />
  );
};

const TextFieldInput = ({
  label,
  fieldKey,
  value,
  onChange,
  onBlur,
  type = "text",
  placeholder,
  helperText,
  required = false,
  error = false,
  errorMessage = "",
  InputLabelProps,
  disabled = false,
  validating = false,
  verified = false,
  verifiedName = null,
  maxLength,
  min,
  uppercase = false,
}) => {
  // Show a spinner while a remote check runs, then a green "Verified" chip
  // once it succeeds (hidden if the field currently has an error).
  const endAdornment =
    validating || (verified && !error) ? (
      <InputAdornment position="end">
        {validating ? (
          <CircularProgress size={18} />
        ) : (
          <Chip
            size="small"
            color="success"
            variant="outlined"
            icon={<CheckCircleOutlineIcon />}
            label="Verified"
            sx={{ height: 24, "& .MuiChip-label": { px: 0.75, fontSize: 12 } }}
          />
        )}
      </InputAdornment>
    ) : undefined;

  // When the registry told us who the document is registered to, surface the
  // name under the field in place of the generic hint.
  const showRegisteredName = verified && !error && verifiedName;

  return (
    <TextField
      required={required}
      fullWidth
      margin="normal"
      size="small"
      label={label}
      type={type}
      value={value}
      placeholder={placeholder}
      helperText={
        error
          ? errorMessage
          : showRegisteredName
          ? `Registered to ${verifiedName}`
          : helperText
      }
      FormHelperTextProps={
        showRegisteredName
          ? { sx: { color: "success.main", fontWeight: 600 } }
          : undefined
      }
      error={error}
      InputLabelProps={InputLabelProps}
      disabled={disabled}
      onChange={(e) =>
        onChange(fieldKey, uppercase ? e.target.value.toUpperCase() : e.target.value)
      }
      onBlur={onBlur ? () => onBlur(fieldKey) : undefined}
      InputProps={{ endAdornment }}
      inputProps={{
        maxLength,
        min,
        style: uppercase ? { textTransform: "uppercase" } : undefined,
      }}
    />
  );
};

// const SectionTitle = ({ children }) => (
//   <Box
//     sx={{
//       mt: 3,
//       border: "2px ",
//       borderRadius: "18px",
//       textAlign: "start",
//       pl: 2,
//       pt: 1,
//       width: "60%",
//       backgroundColor: "rgb(253, 188, 0)",
//     }}
//   >
//     <Typography variant="h6" sx={{ fontWeight: 500,fontSize:"17px",lineHeight:"20px" }} gutterBottom>
//       {children}
//     </Typography>
//     <Divider sx={{ mb: 2 }} />
//   </Box>
// );
const SectionTitle = ({ children }) => (
  <Box sx={{ mt: 3, mb: 1.5 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1 }}>
      <Box
        sx={{
          width: 4,
          height: 20,
          bgcolor: "primary.main",
          flexShrink: 0,
        }}
      />
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: 15,
          lineHeight: 1.2,
          color: "text.primary",
          textTransform: "uppercase",
          letterSpacing: 0.6,
        }}
      >
        {children}
      </Typography>
    </Box>
    <Divider />
  </Box>
);
const TyreBrandSelector = ({ selectedTyreGroups, onSelect }) => {
  return (
    <FormControl fullWidth margin="normal" size="small">
      <InputLabel>Tyre Brand</InputLabel>
      <Select
        value=""
        onChange={(e) => {
          const [group, value] = e.target.value.split("::");
          onSelect(group, value);
        }}
        displayEmpty
      >
        <ListSubheader>Tyre-Group-1</ListSubheader>
        {brandData["Tyre-Group-1"].map((item) => (
          <MenuItem key={item} value={`Tyre-Group-1::${item}`}>
            {item}
          </MenuItem>
        ))}

        <ListSubheader>Tyre-Group-2</ListSubheader>
        {brandData["Tyre-Group-2"].map((item) => (
          <MenuItem key={item} value={`Tyre-Group-2::${item}`}>
            {item}
          </MenuItem>
        ))}
      </Select>

      <Typography variant="body2" mt={2}>
        Group 1 Selected: {selectedTyreGroups["Tyre-Group-1"] || "None"}
        <br />
        Group 2 Selected: {selectedTyreGroups["Tyre-Group-2"] || "None"}
      </Typography>
    </FormControl>
  );
};

// Production-grade document upload field:
// empty dropzone → uploading spinner → image thumbnail (with hover "Replace") → doc-number chip.
const DocumentUploadCard = ({ doc, value, previewUrl, uploading, error, onUpload, onRetry, hasFileToRetry }) => {
  const hasFile = !!value?.code;
  const imgSrc =
    previewUrl ||
    value?.imageUrl ||
    (isHttpUrl(value?.code) ? value.code : "");

  const dropBase = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    gap: 0.75,
    minHeight: 148,
    p: 2,
    border: "1.5px dashed",
    borderColor: error ? "error.main" : "divider",
    bgcolor: "action.hover",
    cursor: "pointer",
    transition: "border-color .2s, background-color .2s",
    "&:hover": { borderColor: "primary.main", bgcolor: "action.selected" },
  };

  return (
    <Box
      sx={{
        height: "100%",
        p: 2,
        border: "1px solid",
        borderColor: error ? "error.main" : "divider",
        display: "flex",
        flexDirection: "column",
        gap: 1.25,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
          <DescriptionOutlinedIcon fontSize="small" color={hasFile ? "success" : "action"} />
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }} noWrap>
            {doc.label}
          </Typography>
        </Box>
        {hasFile && !uploading ? (
          <Chip
            size="small"
            color="success"
            variant="outlined"
            icon={<CheckCircleOutlineIcon />}
            label="Uploaded"
          />
        ) : null}
      </Box>

      {uploading ? (
        <Box sx={{ ...dropBase, cursor: "default", "&:hover": { borderColor: "divider", bgcolor: "action.hover" } }}>
          <CircularProgress size={22} />
          <Typography variant="caption" color="text.secondary">
            Uploading…
          </Typography>
        </Box>
      ) : imgSrc ? (
        <Box
          component="label"
          sx={{
            position: "relative",
            display: "block",
            cursor: "pointer",
            overflow: "hidden",
            border: "1px solid",
            borderColor: "divider",
            "&:hover .doc-overlay": { opacity: 1 },
          }}
        >
          <Box
            component="img"
            src={imgSrc}
            alt={doc.label}
            sx={{ width: "100%", height: 148, objectFit: "contain", display: "block", bgcolor: "action.hover" }}
          />
          <Box
            className="doc-overlay"
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.75,
              color: "common.white",
              bgcolor: (theme) => alpha(theme.palette.common.black, 0.45),
              opacity: 0,
              transition: "opacity .2s",
            }}
          >
            <CloudUploadOutlinedIcon fontSize="small" />
            <Typography variant="button" sx={{ fontWeight: 700 }}>
              Replace
            </Typography>
          </Box>
          <input hidden accept="image/*" type="file" name={doc.key} onChange={onUpload} />
        </Box>
      ) : hasFile ? (
        <Box component="label" sx={dropBase}>
          <DescriptionOutlinedIcon color="action" />
          <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: "break-all" }}>
            Doc No: {value.code}
          </Typography>
          <Typography variant="caption" color="primary" sx={{ fontWeight: 600 }}>
            Click to replace
          </Typography>
          <input hidden accept="image/*" type="file" name={doc.key} onChange={onUpload} />
        </Box>
      ) : (
        <Box component="label" sx={dropBase}>
          <CloudUploadOutlinedIcon sx={{ fontSize: 30 }} color="action" />
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Click to upload
          </Typography>
          <Typography variant="caption" color="text.secondary">
            PNG, JPG or WEBP · up to 5 MB
          </Typography>
          <input hidden accept="image/*" type="file" name={doc.key} onChange={onUpload} />
        </Box>
      )}

      {error ? (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 0.5 }}>
          <FormHelperText error sx={{ mx: 0, mt: 0 }}>
            {error}
          </FormHelperText>
          {hasFileToRetry && !uploading && (
            <Button
              size="small"
              color="error"
              variant="text"
              onClick={onRetry}
              sx={{ py: 0, textTransform: "none", fontWeight: 600, fontSize: "0.75rem", minWidth: "auto" }}
            >
              Try Again
            </Button>
          )}
        </Box>
      ) : null}
    </Box>
  );
};

const DealerOnboardForm = () => {
  const history = useHistory();
  const [formData, setFormData] = useState(getInitialFormData);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  // Tracks in-flight remote (PAN/GST) format checks, keyed by field.
  const [validating, setValidating] = useState({});
  // Tracks fields that passed remote verification, keyed by field.
  const [verified, setVerified] = useState({});
  // Registered name returned by the registry for verified PAN/GST values,
  // keyed by field — shown under the field so the officer can eyeball it
  // against the dealership name.
  const [registeredNames, setRegisteredNames] = useState({});
  const [masterData, setMasterData] = useState({});
  const [sapData, setSapData] = useState({});
  const [userOnBoardData, setUserOnBoardData] = useState({});
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [uploading, setUploading] = useState({});
  const [docPreviews, setDocPreviews] = useState({});
  const [selectedFiles, setSelectedFiles] = useState({});
  const [selectedTyreGroups, setSelectedTyreGroups] = useState({
    "Tyre-Group-1": "",
    "Tyre-Group-2": "",
  });

  const [disableSubmit, setDisableSubmit] = useState(false);
  // Onboarding stage statuses (approvals / payment / SAP) for the saved
  // record — drives the stage chips, banner and submit button below.
  const [onboardStages, setOnboardStages] = useState(null);
  // Preview + confirm-submit dialog (opened by the Submit button).
  const [previewOpen, setPreviewOpen] = useState(false);

  // Two-phase wizard state
  const [activeStep, setActiveStep] = useState(0);

  // Get prospect data from navigation state
  const prospectData = getNavigationState();
  const dealerId = getDealerId();

  console.log("dealerIdprospectData", prospectData);
  // Always show all fields - no hiding logic
  const shouldShowFields = true;
  

  // Resolve prospectId once and keep it stable for deps
  const prospectId = useMemo(() => {
    const st = getNavigationState();
    return st?._id || st?.prospectId || dealerId || null;
  }, [dealerId]);
  const storageKey = useMemo(
    () => makeDealerOnboardStorageKey(dealerId, prospectId),
    [dealerId, prospectId]
  );

  useEffect(() => {
    const persisted = loadPersistedDealerOnboard(storageKey);
    if (persisted?.formData) {
      setFormData((prev) => ({ ...prev, ...persisted.formData }));
    }
    if (persisted?.docPreviews) {
      setDocPreviews(persisted.docPreviews || {});
    }
   
  }, [storageKey]);

  // Fetch prospect data with approval status
  const fetchProspectData = async () => {
    try {
      const token = getAuthToken();
      if (!token) return null;

      const response = await fetch(
        `${REACT_APP_REQUEST_ENDPOINT}/api/v1/actyv/prospects/dealer/searchprospect?search=${prospectId || dealerId || ""}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
 
      if (!response.ok) return null;
      
      const data = await response.json();
      console.log("datadata", data);

      // Find the prospect with matching ID
      const prospect = data.dealerProspects
     
      if (prospect) {
        setUserOnBoardData(prospect);

        // Pull every usable field out of the prospect payload (all optional-chained).
        const basic = prospect.basicInfo || {};
        const contact = basic.firstPersonContact || {};
        const location = basic.location || {};
        const business = prospect.businessInfo || {};
        const createdBy = prospect.createdBy || {};

        const prospectValues = {
          // Geo (Phase 1)
          latitude: location.lat,
          longitude: location.long,
          // Address / region (Phase 1)
          region: createdBy.regionName,
          // Identity & contact (Phase 1)
          dealership_name: business.dealershipName,
          contact_person: contact.name,
          mobile_phone: business.phoneNumber,
          phone_number: business.landline,
          email: business.email,
          gst_number: business.gstin,
          pan: business.panCard || contact.panNo,
          // Business / commercial (Phase 2)
          with_sas: business.proposedSAS,
          noOfYearsBusiness: business.noOfYearTradeTyre || business.noOfYearRetail,
          regionalOffice: createdBy.regionName,
        };

        // Treat empty / null / "0" as "no data" so we never prefill junk.
        const hasValue = (v) =>
          v !== undefined &&
          v !== null &&
          String(v).trim() !== "" &&
          String(v).trim() !== "0";

        setFormData((prev) => {
          const next = { ...prev };
          Object.entries(prospectValues).forEach(([key, val]) => {
            const alreadyFilled = String(prev[key]?.code || "").trim() !== "";
            // Only fill blank fields — never clobber saved / persisted edits.
            if (hasValue(val) && !alreadyFilled) {
              next[key] = { ...(prev[key] || {}), code: String(val).trim() };
            }
          });
          try {
            savePersistedDealerOnboard(storageKey, { formData: next, docPreviews });
          } catch (_) {}
          return next;
        });
      }

      
      return null;
    } catch (error) {
      console.error("Failed to fetch prospect data:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      // Mark as loading initially
      setIsDataLoaded(false);
     

      const fetchSapData = async () => {
        try {
          const fallbackData = await getCustomerGroupData();
          
        //   if (sapRes?.data) {
        //     setSapData(sapRes.data);
        //     console.log("SAP data loaded:", sapRes.data);
        //   }
        // } catch (err) {
        //   console.warn("SAP API failed, trying fallback onboarding API:", err);
        //   // Fallback to onboarding API
        //   try {
        //     const fallbackResponse = await fetch(`${REACT_APP_REQUEST_ENDPOINT}/api/v1/actyv/onboarding`);
        //     const fallbackData = await fallbackResponse.json();
            
            console.log("fallbackDatafallbackData", fallbackData);
            if (fallbackData?.data) {
              // Transform fallback data to match SAP format
              const transformedData = {
                customer_group: fallbackData.data.customer_group?.map(item => ({
                  code: item.code,
                  name: item.name
                })) || [],
                price_group:fallbackData.data.price_group?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                price_list:fallbackData.data.price_list?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                account_group:fallbackData.data.account_group?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                account_assignment_group:fallbackData.data.account_assignment_group?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                // reconciliation_account:fallbackData.data.reconciliation_account?.map(item => ({
                //   code: item.code,
                //   name: item.description
                // })) || [],
                customer_pricing_procedure: fallbackData.data.customer_pricing_procedure?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                terms_of_payment: fallbackData.data.terms_of_payment?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                // incoterms: fallbackData.data.incoterms?.map(item => ({
                //   code: item.code,
                //   name: item.description
                // })) || [],
                sales_office: fallbackData.data.sales_office?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                distribution_channel: fallbackData.data.distribution_channel?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                // division: fallbackData.data.division?.map(item => ({
                //   code: item.code,
                //   name: item.description
                // })) || [],
                state: fallbackData.data.state?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                customer_class: fallbackData.data.customer_class?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                status: fallbackData.data.status?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || []
              };
              
              setSapData(transformedData);
              console.log("Fallback onboarding data loaded:", transformedData);
            }
          } catch (fallbackError) {
            console.warn("Fallback onboarding API also failed:", fallbackError);
          }
        // }
      };

      // Load saved onboarding form from backend and prefill
      const fetchSavedOnboardData = async () => {
        try {
          const token = getAuthToken();
          const id = prospectId || dealerId;
          if (!token || !id) return;
          const url = `${REACT_APP_REQUEST_ENDPOINT}/api/v1/actyv/onboarding/user?prospectId=${encodeURIComponent(id)}`;
          const res = await fetch(url, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });

          if (!res.ok) return;
          const json = await res.json().catch(() => ({}));
          const formObj =
            json?.data?.form ||
            json?.form ||
            (json?.data && typeof json.data === "object" ? json.data : null);

            if(formObj?.userOnBoard){
              setDisableSubmit(true);
            }
          if (formObj && typeof formObj === "object") {
            setOnboardStages({
              userOnBoard:
                formObj.userOnBoard === true || formObj.userOnBoard === "true",
              soApproval: formObj.soApproval || "N/A",
              soApprovalMessage: formObj.soApprovalMessage || "",
              finalApproval: formObj.finalApproval || "N/A",
              finalApprovalMessage: formObj.finalApprovalMessage || "",
              paymentStatus: formObj.paymentStatus || "N/A",
              paymentStatusMessage: formObj.paymentStatusMessage || "",
              sapStatus: formObj.sapStatus || "N/A",
              sapStatusMessage: formObj.sapStatusMessage || "",
              kunnr: formObj.kunnr && formObj.kunnr !== "N/A" ? formObj.kunnr : "",
              onboardingFailsReason: formObj.onboardingFailsReason || "",
            });
            const normalized = normalizeIncomingForm(formObj);

            setFormData((prev) => {
              const next = { ...prev, ...normalized };
              // savePersistedDealerOnboard(storageKey, {
              //   formData: next,
              //   docPreviews,
              // });
              return next;
            });
          }
        } catch (_) {
          // ignore
        }
      };


      const fetchProspectDataAsync = async () => {
        try {
          await fetchProspectData();
        } catch (err) {
          // Prospect data fetch failed, continue without it
        }
      };


      // Execute all API calls independently
      await Promise.allSettled([
        fetchSavedOnboardData(),
        // fetchMasterData(),
        fetchSapData(),
        fetchProspectDataAsync(),
        // fetchDealerOnboardData()
      ]);

      // Always mark as loaded, regardless of API results
      setIsDataLoaded(true);
    };

    fetchData();
  }, [prospectId, dealerId]);

  // Derive the submit button label, disabled state and status banner from the
  // stage statuses. The labels mirror what the backend actually does on the
  // next submit (resend approval email / regenerate payment link / retry SAP).
  const stageFlow = useMemo(() => {
    const s = onboardStages;
    if (!s) return { label: "Submit", disabled: false, alert: null };
    const lc = (v) => (v || "").toString().trim().toLowerCase();
    const ok = (v) => ["accepted", "success", "paid"].includes(lc(v));
    const bad = (v) => ["rejected", "failed", "error"].includes(lc(v));
    const waiting = (v) =>
      ["pending", "initiated", "in progress", "waiting"].includes(lc(v));

    if (s.userOnBoard || ok(s.sapStatus)) {
      return {
        label: "Onboarded",
        disabled: true,
        alert: {
          severity: "success",
          text: `Dealer is fully onboarded${
            s.kunnr ? ` — SAP customer ID ${s.kunnr}` : ""
          }. The form is read-only.`,
        },
      };
    }
    if (ok(s.paymentStatus)) {
      return {
        label: bad(s.sapStatus)
          ? "Retry SAP Dealer Creation"
          : "Create Dealer in SAP",
        disabled: false,
        alert: bad(s.sapStatus)
          ? {
              severity: "error",
              text:
                s.sapStatusMessage ||
                s.onboardingFailsReason ||
                "SAP dealer creation failed. Fix the highlighted fields and retry.",
            }
          : {
              severity: "info",
              text:
                s.sapStatusMessage ||
                "Payment received. Submitting will create the dealer in SAP.",
            },
      };
    }
    if (ok(s.soApproval) && ok(s.finalApproval)) {
      return {
        label:
          waiting(s.paymentStatus) || bad(s.paymentStatus)
            ? "Regenerate Payment Link"
            : "Generate Payment Link",
        disabled: false,
        alert: bad(s.paymentStatus)
          ? {
              severity: "error",
              text:
                s.paymentStatusMessage ||
                "Payment failed or was cancelled. Submitting regenerates the payment link.",
            }
          : waiting(s.paymentStatus)
          ? {
              severity: "warning",
              text:
                s.paymentStatusMessage ||
                "Payment link generated, awaiting payment.",
            }
          : {
              severity: "info",
              text: "Approvals complete. Submitting generates the dealer payment link.",
            },
      };
    }
    if (ok(s.soApproval)) {
      return {
        label: waiting(s.finalApproval)
          ? "Resend Final Approval Email"
          : bad(s.finalApproval)
          ? "Resubmit for Final Approval"
          : "Send for Final Approval",
        disabled: false,
        alert: bad(s.finalApproval)
          ? {
              severity: "error",
              text:
                s.finalApprovalMessage ||
                "Final approval was rejected. Update the form and resubmit.",
            }
          : waiting(s.finalApproval)
          ? {
              severity: "warning",
              text: s.finalApprovalMessage || "Awaiting final approval.",
            }
          : {
              severity: "info",
              text: "Sales admin approval done. Submitting sends the final approval email.",
            },
      };
    }
    return {
      label: waiting(s.soApproval)
        ? "Resend Sales Admin Approval Email"
        : bad(s.soApproval)
        ? "Resubmit for Sales Admin Approval"
        : "Submit",
      disabled: false,
      alert: bad(s.soApproval)
        ? {
            severity: "error",
            text:
              s.soApprovalMessage ||
              "Sales admin approval was rejected. Update the form and resubmit.",
          }
        : waiting(s.soApproval)
        ? {
            severity: "warning",
            text: s.soApprovalMessage || "Awaiting sales admin approval.",
          }
        : null,
    };
  }, [onboardStages]);

  // Onboarding complete → the whole form is read-only.
  const formReadOnly = stageFlow.disabled;

  // Sales Officer (SO) who created this prospect — shown read-only on Step 1
  // (Basic Details). Sourced from the prospect's `createdBy` record; field
  // names are optional-chained/fallback so we surface whatever the API returns.
  const soCreatedBy = userOnBoardData?.createdBy || {};
  const salesOfficer = {
    sapId: soCreatedBy.SAP_ID || soCreatedBy.sapId || "-",
    name:
      soCreatedBy.name ||
      soCreatedBy.fullName ||
      soCreatedBy.userName ||
      soCreatedBy.employeeName ||
      "-",
    region: soCreatedBy.regionName || soCreatedBy.region || "-",
    email: soCreatedBy.email || soCreatedBy.emailId || "-",
    phone:
      soCreatedBy.phoneNumber ||
      soCreatedBy.mobileNumber ||
      soCreatedBy.mobile ||
      soCreatedBy.phone ||
      "-",
  };

  // Validation helpers
  const validateField = (key, valueOverride) => {
    const rules = validationRules[key];
    if (!rules || !Array.isArray(rules)) return null;
    const value = valueOverride !== undefined ? valueOverride : formData[key];
    for (const rule of rules) {
      if (typeof rule.fn === "function") {
        const passed = rule.fn(value);
        if (!passed) return rule.message || "Invalid value.";
      }
    }
    return null;
  };

  const validateAll = (data = formData) => {
    const nextErrors = {};
    Object.keys(validationRules).forEach((key) => {
      const message = validateField(key, data[key]);
      if (message) nextErrors[key] = message;
    });
    return nextErrors;
  };

  const fieldProps = (key) => ({
    error: !!errors[key],
    errorMessage: errors[key] || "",
    required: isRequiredField(key),
  });

  // Normalize DB/API payload to our { code, label } structure per key
  const normalizeIncomingForm = (incoming = {}) => {
    const result = {};
    Object.keys(initialFormData).forEach((key) => {
      const val = incoming[key];
      if (val !== undefined && val !== null) {
        if (typeof val === "object" && !Array.isArray(val)) {
          // Prefer common shapes: code/label, name/value/text, plus imageUrl variants
          const codeCandidate =
            val.code ??
            val.label ?? // sometimes label holds value
            val.name ??
            val.value ??
            val.text ??
            "";
          const labelCandidate = val.label ?? val.name ?? "";
          result[key] = {
            code: codeCandidate != null ? String(codeCandidate) : "",
            label: labelCandidate != null ? String(labelCandidate) : "",
            imageUrl: val.imageUrl || val.ImageUrl || val.imgUrl || "",
          };
        } else {
          // Primitive → treat as text
          result[key] = { code: String(val), label: "", imageUrl: "" };
        }
      } 
    });
    return result;
  };


  // Accept object for Selects, string for TextFields
  const handleFieldChange = (fieldKey, value) => {
    console.log("valuevalue", value);
    const newValue =
      value && typeof value === "object"
        ? value
        : { ...(formData[fieldKey] || {}), code: value };
    const nextFormData = {
      ...formData,
      [fieldKey]: newValue,
    };
    setFormData(nextFormData);
    savePersistedDealerOnboard(storageKey, {
      formData: nextFormData,
      docPreviews,
    });

    setTouched((prev) => ({ ...prev, [fieldKey]: true }));
    if (validationRules[fieldKey]) {
      const message = validateField(fieldKey, newValue);
      setErrors((prev) => {
        const n = { ...prev };
        if (message) n[fieldKey] = message;
        else delete n[fieldKey];
        return n;
      });
    }
    // A changed PAN/GST value must be re-verified.
    if (REMOTE_VALIDATORS[fieldKey] && verified[fieldKey]) {
      setVerified((prev) => ({ ...prev, [fieldKey]: false }));
      setRegisteredNames((prev) => ({ ...prev, [fieldKey]: null }));
    }
  };

  const handleFieldBlur = async (fieldKey) => {
    const apiFn = REMOTE_VALIDATORS[fieldKey];
    if (!apiFn) return;

    setTouched((prev) => ({ ...prev, [fieldKey]: true }));

    // Run local (required + format) rules first; skip the API call if they fail.
    const localError = validateField(fieldKey, formData[fieldKey]);
    if (localError) {
      setErrors((prev) => ({ ...prev, [fieldKey]: localError }));
      setVerified((prev) => ({ ...prev, [fieldKey]: false }));
      return;
    }

    const value = (formData[fieldKey]?.code || "").toString().trim();
    if (!value) {
      setVerified((prev) => ({ ...prev, [fieldKey]: false }));
      return;
    }

    try {
      setValidating((prev) => ({ ...prev, [fieldKey]: true }));
      const res = await apiFn(value);
      const isValid = !!res?.data?.valid;
      setErrors((prev) => {
        const n = { ...prev };
        if (isValid) delete n[fieldKey];
        else n[fieldKey] = res?.message || "Invalid value.";
        return n;
      });
      setVerified((prev) => ({ ...prev, [fieldKey]: isValid }));
      // Name on the registry record (Decentro) — only meaningful when valid.
      setRegisteredNames((prev) => ({
        ...prev,
        [fieldKey]: isValid ? res?.data?.registeredName || null : null,
      }));
    } catch (e) {
      // Network/server error: don't hard-block the user; local validation stands.
      console.error(`${fieldKey} remote validation failed`, e);
    } finally {
      setValidating((prev) => ({ ...prev, [fieldKey]: false }));
    }
  };

  const scrollToTop = () => {
    // Specifically target section wrappers to avoid utility divs with the same classes
    const scrollers = document.querySelectorAll("section.details-container, section.main-container, .details-container, .main-container");
    scrollers.forEach((el) => {
      try {
        el.scrollTo({ top: 0, behavior: "auto" });
        el.scrollTop = 0;
      } catch (_) {}
    });
    window.scrollTo({ top: 0, behavior: "auto" });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      scrollToTop();
    }, 50);
    return () => clearTimeout(timer);
  }, [activeStep]);

  // Validate only the given field keys (used to gate a phase transition).
  const validatePhase = (keys) => {
    setTouched((prev) => {
      const next = { ...prev };
      keys.forEach((k) => (next[k] = true));
      return next;
    });
    const phaseErrors = {};
    keys.forEach((k) => {
      const message = validateField(k, formData[k]);
      if (message) phaseErrors[k] = message;
    });
    setErrors((prev) => {
      const merged = { ...prev };
      keys.forEach((k) => {
        if (phaseErrors[k]) merged[k] = phaseErrors[k];
        else delete merged[k];
      });
      return merged;
    });
    return Object.keys(phaseErrors).length === 0;
  };

  const handleNext = () => {
    if (!validatePhase(PHASE1_VALIDATED_FIELDS)) {
      toastMessage("Please fix highlighted errors before continuing.", "error");
      return;
    }
    setActiveStep(1);
    scrollToTop();
  };

  const handleBack = () => {
    setActiveStep(0);
    scrollToTop();
  };

  const handleSubmit = async () => {
  // Touch all fields and validate before preview
  const allTouched = Object.keys(formData).reduce((acc, k) => {
    acc[k] = true;
    return acc;
  }, {});
  setTouched(allTouched);
  const nextErrors = validateAll(formData);
  setErrors(nextErrors);
  if (Object.keys(nextErrors).length > 0) {
    // If any error is on a Phase 1 field, send the user back so they can see it.
    const hasPhase1Error = PHASE1_VALIDATED_FIELDS.some((k) => nextErrors[k]);
    if (hasPhase1Error) {
      setActiveStep(0);
      scrollToTop();
    }
    toastMessage("Please fix highlighted errors before submitting.", "error");
    return;
  }
  // Open the preview + submit dialog
  setPreviewOpen(true);
}

  const handleCancel = () => {
    window.history.back();
  };

  const performUpload = async (fieldName, file) => {
    if (!file) return;
    try {
      // start loader and set local preview
      setUploading((prev) => ({ ...prev, [fieldName]: true }));
      try {
        // revoke old url if exists
        if (docPreviews[fieldName]) {
          try { URL.revokeObjectURL(docPreviews[fieldName]); } catch (_) {}
        }
      } catch (_) {}
      const localPreviewUrl = URL.createObjectURL(file);
      setDocPreviews((prev) => {
        const next = { ...prev, [fieldName]: localPreviewUrl };
        savePersistedDealerOnboard(storageKey, {
          formData,
          docPreviews: next,
        });
        return next;
      });

      const formDataToSend = new FormData();
      formDataToSend.append("image", file);
  
      const token = localStorage.getItem("token");  

      // Single upload: the backend stores the file in SAP (returns docNo) and,
      // on success, in S3 (returns imgUrl for preview). One call handles both.
      const response = await fetch(`${process.env.REACT_APP_REQUEST_ENDPOINT}/api/v1/actyv/onboarding/upload-document`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      const data = await response.json();

      // Response shape: { status, message, data: { docNo, imgUrl, documentUrl, filename, mimetype } }
      // (older builds returned fields at the top level) — support both.
      const uploadResult = data?.data || data || {};
      const docNo = uploadResult.docNo ?? data?.docNo ?? null;
      const imgUrl = uploadResult.imgUrl ?? data?.imgUrl ?? null;

      if (docNo) {
        // SAP docNo -> `code` (sent to SAP on create); S3 URL -> `imageUrl` (preview).
        setFormData((prev) => {
          const next = {
            ...prev,
            [fieldName]: {
              ...prev[fieldName],
              code: docNo,
              imageUrl: imgUrl || prev[fieldName]?.imageUrl || "",
            },
          };
          savePersistedDealerOnboard(storageKey, {
            formData: next,
            docPreviews,
          });
          return next;
        });
        // Replace the local object-URL preview with the remote S3 URL.
        if (imgUrl) {
          setDocPreviews((prev) => {
            const next = { ...prev, [fieldName]: imgUrl };
            savePersistedDealerOnboard(storageKey, {
              formData,
              docPreviews: next,
            });
            return next;
          });
        }
        // Clear previous error for this field on success
        setErrors((prev) => {
          const n = { ...prev };
          delete n[fieldName];
          return n;
        });
      } else {
        console.error("Upload failed: No docNo returned", data);
        setErrors((prev) => ({ ...prev, [fieldName]: "Upload failed. Try again." }));
        toastMessage("Upload failed. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      setErrors((prev) => ({ ...prev, [fieldName]: "Upload failed. Try again." }));
      toastMessage("Upload failed. Please try again.", "error");
    } finally {
      setUploading((prev) => ({ ...prev, [fieldName]: false }));
    }
  };

  const uploadFile = async (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;
    
    if (!file) return;
  
    // Client-side file validation
    if (file.size > MAX_FILE_SIZE) {
      setErrors((prev) => ({ ...prev, [fieldName]: "File must be 5 MB or smaller." }));
      toastMessage("File too large (max 5 MB).", "error");
      return;
    }
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      setErrors((prev) => ({ ...prev, [fieldName]: "Only JPG, PNG, WEBP, or GIF allowed." }));
      toastMessage("Unsupported file type.", "error");
      return;
    }

    setSelectedFiles((prev) => ({ ...prev, [fieldName]: file }));
    await performUpload(fieldName, file);
  };

  const handleRetry = async (fieldName) => {
    const file = selectedFiles[fieldName];
    if (file) {
      await performUpload(fieldName, file);
    } else {
      toastMessage("No file selected to retry.", "error");
    }
  };
  

  return (
    <Container maxWidth="md" sx={{ mt: 2, mb: 2 }}>
      <PageHeader
        title="Add Dealer"
        subtitle="Fill the customer onboarding details. Fields marked * are required."
        action={
          <Button
            variant="text"
            startIcon={<ArrowBackIcon />}
            onClick={handleCancel}
            sx={{
              color: "text.secondary",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { backgroundColor: "action.hover" },
            }}
          >
            Back
          </Button>
        }
      />
      <SectionCard contentSx={{ p: { xs: 2, md: 2.5 } }}>
        {/* Two-phase wizard progress */}
        <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
          {WIZARD_STEPS.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Onboarding stage statuses for the saved record */}
        {onboardStages && (
          <Box sx={{ mb: 3 }}>
            <Stack
              direction="row"
              spacing={1}
              flexWrap="wrap"
              useFlexGap
              sx={{ mb: stageFlow.alert ? 1.5 : 0 }}
            >
              <StageStatusChip
                label="Sales Admin Approval"
                status={onboardStages.soApproval}
                message={onboardStages.soApprovalMessage}
              />
              <StageStatusChip
                label="Final Approval"
                status={onboardStages.finalApproval}
                message={onboardStages.finalApprovalMessage}
              />
              <StageStatusChip
                label="Payment"
                status={onboardStages.paymentStatus}
                message={onboardStages.paymentStatusMessage}
              />
              <StageStatusChip
                label="SAP"
                status={onboardStages.sapStatus}
                message={
                  onboardStages.sapStatusMessage ||
                  onboardStages.onboardingFailsReason
                }
                successLabel={onboardStages.kunnr}
              />
            </Stack>
            {stageFlow.alert && (
              <Alert severity={stageFlow.alert.severity}>
                {stageFlow.alert.text}
              </Alert>
            )}
          </Box>
        )}

        {/* {prospectData && (
          <Box sx={{ mb: 3, p: 2, bgcolor: "grey.100", borderRadius: 1 }}>
            <Typography variant="h6" gutterBottom>
              Prospect Information
            </Typography>
            <Typography variant="body2">From: {prospectData.from}</Typography>
            <Typography variant="body2">
              Prospect ID: {prospectData.prospectId}
            </Typography>
            <Typography variant="body2">
              Dealer ID: {dealerId || "—"}
            </Typography>
          </Box>
        )} */}

        {!isDataLoaded && (
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            py: 8,
            gap: 2
          }}>
            <CircularProgress size={40} />
            <Typography variant="body1" color="text.secondary">
              Loading form data...
            </Typography>
          </Box>
        )}
        
        
        {/* Once the dealer is onboarded the whole form becomes read-only:
            the fieldset disables every native input and pointer events are
            blocked for uploads/autocomplete popups. */}
        <Box
          component="fieldset"
          disabled={formReadOnly}
          sx={{
            border: 0,
            p: 0,
            m: 0,
            minWidth: 0,
            ...(formReadOnly && { opacity: 0.65, pointerEvents: "none" }),
          }}
        >
        <Grid container columnSpacing={3} rowSpacing={2}>
          {/* ===== PHASE 2 · Business & Commercial ===== */}
          {activeStep === 1 && (
            <>
          {/* SAP & Pricing Section */}
          <Grid item xs={12}>
            <SectionTitle>SAP &amp; Pricing</SectionTitle>
          </Grid>
          {/* Customer Group */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Customer Group"
              fieldKey="customer_group"
              // options={sapData.customerGrp || []}
              options={sapData.customer_group || []}
              value={formData.customer_group}
              onChange={handleFieldChange}
              {...fieldProps("customer_group")}
            />
          </Grid>

          {/* Customer Pricing Procedure */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Customer Pricing Procedure"
              fieldKey="customer_pricing_procedure"
              // options={sapData.customerPriceProc || []}
              options={sapData.customer_pricing_procedure || []}
              value={formData.customer_pricing_procedure}
              onChange={handleFieldChange}
              {...fieldProps("customer_pricing_procedure")}
            />
          </Grid>

          {/* Terms of Payment */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Terms of Payment"
              fieldKey="terms_of_payment"
              // options={sapData.payTerms || []}
              options={sapData.terms_of_payment || []}
              value={formData.terms_of_payment}
              onChange={handleFieldChange}
              {...fieldProps("terms_of_payment")}
            />
          </Grid>

          {/* Incoterms */}
          {/* <Grid item xs={12} md={6}>
            <SapSelectField
              label="Incoterms"
              fieldKey="incoterms"
              // options={sapData.incoTerms || []}
              options={sapData.incoterms || []}
              value={formData.incoterms}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* Account Assignment Group */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Account Assignment Group"
              fieldKey="account_assignment_group"
              options={sapData.account_assignment_group || []}
              value={formData.account_assignment_group}
              onChange={handleFieldChange}
              {...fieldProps("account_assignment_group")}
            />
          </Grid>

          {/* Reconciliation Account */}
          {/* <Grid item xs={12} md={6}>
            <SapSelectField
              label="Reconciliation Account"
              fieldKey="reconciliation_account"
              options={sapData.reconciliation_account || []}
              value={formData.reconciliation_account}
              onChange={handleFieldChange}
              {...fieldProps("reconciliation_account")}
            />
          </Grid> */}

          {/* Org Structure Section */}
          <Grid item xs={12}>
            <SectionTitle>Org Structure</SectionTitle>
          </Grid>
          {/* Account Group */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Account Group"
              fieldKey="account_group"
              // options={masterData.account_group || []}
              options={sapData.account_group || []}
              value={formData.account_group}
              onChange={handleFieldChange}
              {...fieldProps("account_group")}
            />
          </Grid>
          {/* Company Code */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Company Code"
              fieldKey="company_code"
              value={formData.company_code.code}
              onChange={handleFieldChange}
              {...fieldProps("company_code")}
            />
          </Grid> */}
          {/* Sales Org */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Sales Org"
              fieldKey="sales_org"
              value={formData.sales_org.code}
              onChange={handleFieldChange}
              {...fieldProps("sales_org")}
            />
          </Grid> */}

          {/* Sales Office */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Sales Office"
              fieldKey="sales_office"
              // options={sapData.salesOffice || []}
              options={sapData.sales_office || []}
              value={formData.sales_office}
              onChange={handleFieldChange}
              {...fieldProps("sales_office")}
            />
          </Grid>

          {/* Distribution Channel */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Distribution Channel"
              fieldKey="distribution_channel"
              // options={sapData.distributionChannel || []}
              options={sapData.distribution_channel || []}
              value={formData.distribution_channel}
              onChange={handleFieldChange}
              {...fieldProps("distribution_channel")}
            />
          </Grid>
          {/* With SAS */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="With SAS"
              fieldKey="with_sas"
              value={formData.with_sas.code}
              onChange={handleFieldChange}
              type="number"
              min={SAS_MIN_AMOUNT}
              helperText={`Minimum ${formatINR(SAS_MIN_AMOUNT)}`}
              {...fieldProps("with_sas")}
            />
          </Grid>
          {/* Title */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Title"
              fieldKey="title"
              value={formData.title.code}
              onChange={handleFieldChange}
              {...fieldProps("title")}
            />
          </Grid> */}

          {/* Customer Classification Section */}
          <Grid item xs={12}>
            <SectionTitle>Customer Classification</SectionTitle>
          </Grid>
          {/* Division */}
          {/* <Grid item xs={12} md={6}>
            <SapSelectField
              label="Division"
              fieldKey="division"
              options={sapData.division || []}
              value={formData.division}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* State */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="State"
              fieldKey="state"
              options={sapData.state || []}
              value={formData.state}
              onChange={handleFieldChange}
              {...fieldProps("state")}
            />
          </Grid>

          {/* Customer Class */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Customer Class"
              fieldKey="customer_class"
              // options={sapData.customerClass || []}
              options={sapData.customer_class || []}
              value={formData.customer_class}
              onChange={handleFieldChange}
              {...fieldProps("customer_class")}
            />
          </Grid>

          {/* Status */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Entity"
              fieldKey="status"
              // options={sapData.customerStatus || []}
              options={sapData.status || []}
              value={formData.status}
              onChange={handleFieldChange}
              {...fieldProps("status")}
            />
          </Grid>

          {/* Price Group */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Price Group"
              fieldKey="price_group"
              // options={PRICE_GROUP_OPTIONS}
              options={sapData.price_group || []}
              value={formData.price_group}
              onChange={handleFieldChange}
              {...fieldProps("price_group")}
            />
          </Grid>

          {/* Price List */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Price List"
              fieldKey="price_list"
              // options={PRICE_LIST_OPTIONS}
              options={sapData.price_list || []}
              value={formData.price_list}
              onChange={handleFieldChange}
              {...fieldProps("price_list")}
            />
          </Grid>

            </>
          )}
          {/* ===== PHASE 1 · Basic Details ===== */}
          {activeStep === 0 && (
            <>
          {/* Sales Officer Section (read-only) — who submitted this prospect */}
          {userOnBoardData?.createdBy && (
            <>
              <Grid item xs={12}>
                <SectionTitle>Sales Officer</SectionTitle>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  margin="normal"
                  size="small"
                  label="Sales Officer SAP ID"
                  value={salesOfficer.sapId}
                  disabled
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  margin="normal"
                  size="small"
                  label="Sales Officer Name"
                  value={salesOfficer.name}
                  disabled
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  margin="normal"
                  size="small"
                  label="Region"
                  value={salesOfficer.region}
                  disabled
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  margin="normal"
                  size="small"
                  label="Sales Officer Email"
                  value={salesOfficer.email}
                  disabled
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  margin="normal"
                  size="small"
                  label="Sales Officer Phone"
                  value={salesOfficer.phone}
                  disabled
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </>
          )}
          {/* Address Section */}
          <Grid item xs={12}>
            <SectionTitle>Address</SectionTitle>
          </Grid>
          {/* dealership_name */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Dealership Name"
              fieldKey="dealership_name"
              value={formData.dealership_name.code}
              onChange={handleFieldChange}
              disabled
              {...fieldProps("dealership_name")}
            />
          </Grid>
          {/* dealership_add */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Dealership Address"
              fieldKey="dealership_add"
              value={formData.dealership_add.code}
              onChange={handleFieldChange}
              {...fieldProps("dealership_add")}
            />
          </Grid>
          {/* Street/House No. */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street/House No."
              fieldKey="street_house_no"
              value={formData.street_house_no.code}
              onChange={handleFieldChange}
              {...fieldProps("street_house_no")}
            />
          </Grid> */}
          {/* C/O */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="C/O"
              fieldKey="care_of"
              value={formData.care_of.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Street 2 */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street 2"
              fieldKey="street2"
              value={formData.street2.code}
              onChange={handleFieldChange}
            />
          </Grid> */}
          {/* Street 3 */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street 3"
              fieldKey="street3"
              value={formData.street3.code}
              onChange={handleFieldChange}
            />
          </Grid> */}
          {/* Street 5 */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street 5"
              fieldKey="street5"
              value={formData.street5.code}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* Tyre Brand Selector (optional) */}
          {/* <Grid item xs={12} md={6}>
            <TyreBrandSelector
              selectedTyreGroups={selectedTyreGroups}
              onSelect={handleTyreGroupSelect}
            />
          </Grid> */}

          {/* Contact Section */}
          <Grid item xs={12}>
            <SectionTitle>Contact</SectionTitle>
          </Grid>
     

          {/* Contact Person */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Dealer name"
              fieldKey="contact_person"
              value={formData.contact_person.code}
              onChange={handleFieldChange}
              {...fieldProps("contact_person")}
            />
          </Grid>

          {/* Phone Number */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Landline Number"
              fieldKey="phone_number"
              value={formData.phone_number.code}
              placeholder="9876543210"
              helperText="Primary contact number"
              onChange={handleFieldChange}
              {...fieldProps("phone_number")}
            />
          </Grid> */}

          {/* Email */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Email"
              fieldKey="email"
              type="email"
              value={formData.email.code}
              onChange={handleFieldChange}
              {...fieldProps("email")}
            />
          </Grid>

          {/* Address */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Address"
              fieldKey="address"
              value={formData.address.code}
              onChange={handleFieldChange}
              {...fieldProps("address")}
            />
          </Grid>

          {/* City */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="City"
              fieldKey="city"
              value={formData.city.code}
              onChange={handleFieldChange}
              {...fieldProps("city")}
            />
          </Grid>

          {/* Postal Code */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Postal Code"
              fieldKey="postal_code"
              value={formData.postal_code.code}
              placeholder="123456"
              helperText="6-digit PIN code"
              onChange={handleFieldChange}
              {...fieldProps("postal_code")}
            />
          </Grid>

          {/* Region */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Region"
              fieldKey="region"
              value={formData.region.code}
              onChange={handleFieldChange}
              {...fieldProps("region")}
            />
          </Grid>
          {/* District */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="District"
              fieldKey="district"
              value={formData.district.code}
              onChange={handleFieldChange}
              {...fieldProps("district")}
            />
          </Grid>
          {/* Different City */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Different City"
              fieldKey="different_city"
              value={formData.different_city.code}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* Mobile Phone */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Mobile Phone"
              fieldKey="mobile_phone"
              value={formData.mobile_phone.code}
              placeholder="9876543210"
              disabled
              helperText="Alternate mobile number"
              onChange={handleFieldChange}
              {...fieldProps("mobile_phone")}
            />
          </Grid>
          {/* Telephone */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Telephone"
              fieldKey="telephone"
              value={formData.telephone.code}
              onChange={handleFieldChange}
            />
          </Grid> */}
          {/* FAX */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="FAX"
              fieldKey="fax"
              value={formData.fax.code}
              onChange={handleFieldChange}
            />
          </Grid> */}

          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Passport Details"
              fieldKey="passportDetails"
              value={formData.passportDetails.code}
              onChange={handleFieldChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Father's Name"
              fieldKey="fatherName"
              value={formData.fatherName.code}
              onChange={handleFieldChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Date of Birth"
              fieldKey="dateOfBirth"
              type="date"
              value={formData.dateOfBirth.code}
              InputLabelProps={{ shrink: true }}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Tax & Compliance Section */}
          <Grid item xs={12}>
            <SectionTitle>Tax &amp; Compliance</SectionTitle>
          </Grid>
          {/* Tax Number 3 */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Tax Number 3"
              fieldKey="tax_number_3"
              value={formData.tax_number_3.code}
              onChange={handleFieldChange}
            />
          </Grid> */}
          {/* PAN */}
               {/* GST Number */}
               
               <Grid item xs={12} md={6}>
            <TextFieldInput
              label="GST Number"
              fieldKey="gst_number"
              value={formData.gst_number.code}
              placeholder="22AAAAA0000A1Z5"
              helperText="As per GSTIN"
              maxLength={15}
              uppercase
              onChange={handleFieldChange}
              onBlur={handleFieldBlur}
              validating={!!validating.gst_number}
              verified={!!verified.gst_number}
              verifiedName={registeredNames.gst_number}
             {...fieldProps("gst_number")}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="PAN"
              fieldKey="pan"
              value={formData.pan.code}
              placeholder="ABCDE1234Q"
              helperText="10-character PAN"
              maxLength={10}
              uppercase
              onChange={handleFieldChange}
              onBlur={handleFieldBlur}
              validating={!!validating.pan}
              verified={!!verified.pan}
              verifiedName={registeredNames.pan}
              {...fieldProps("pan")}
            />
          </Grid>
          <Grid  item xs={12} md={6}>

          </Grid>

          {/* Uploads Section: aligned in grid */}
          <Grid item xs={12}>
            <SectionTitle>Documents</SectionTitle>
          </Grid>
          {DOCUMENT_UPLOADS.map((doc) => (
            <Grid key={doc.key} item xs={12} md={6}>
              <DocumentUploadCard
                doc={doc}
                value={formData[doc.key]}
                previewUrl={docPreviews[doc.key]}
                uploading={!!uploading[doc.key]}
                error={errors[doc.key]}
                onUpload={uploadFile}
                onRetry={() => handleRetry(doc.key)}
                hasFileToRetry={!!selectedFiles[doc.key]}
              />
            </Grid>
          ))}




            </>
          )}
          {/* ===== PHASE 2 · Business & Commercial (cont.) ===== */}
          {activeStep === 1 && (
            <>
          {/* Commercial Settings Section */}
          <Grid item xs={12}>
            <SectionTitle>Commercial Settings</SectionTitle>
          </Grid>
          {/* Customer Statistic Group */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Customer Statistic Group"
              fieldKey="customer_statistic_group"
              value={formData.customer_statistic_group.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Delivering Plant */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Delivering Plant"
              fieldKey="delivering_plant"
              value={formData.delivering_plant.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Rebate */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Rebate"
              fieldKey="rebate"
              value={formData.rebate.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Incoterms1 */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Incoterms1"
              fieldKey="incoterms1"
              value={formData.incoterms1.code}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* Commercial Officer Section */}
          <Grid item xs={12}>
            <SectionTitle>Commercial Officer Details</SectionTitle>
          </Grid>
          {/* Commercial Officer Name */}
          <Grid item xs={12} md={4}>
            <TextFieldInput
              label="Commercial Officer Name"
              fieldKey="commercialOfficerName"
              value={formData.commercialOfficerName ? formData.commercialOfficerName.code : ""}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Commercial Officer Email */}
          <Grid item xs={12} md={4}>
            <TextFieldInput
              label="Commercial Officer Email"
              fieldKey="commercialOfficerEmail"
              value={formData.commercialOfficerEmail ? formData.commercialOfficerEmail.code : ""}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Commercial Officer Phone */}
          <Grid item xs={12} md={4}>
            <TextFieldInput
              label="Commercial Officer Phone"
              fieldKey="commercialOfficerPhone"
              value={formData.commercialOfficerPhone ? formData.commercialOfficerPhone.code : ""}
              onChange={handleFieldChange}
            />
          </Grid>

            </>
          )}
          {/* ===== PHASE 1 · Basic Details (cont.) ===== */}
          {activeStep === 0 && (
            <>
          {/* Geo & Limits Section */}
          <Grid item xs={12}>
            <SectionTitle>Geo &amp; Limits</SectionTitle>
          </Grid>
          {/* Latitude */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Latitude"
              fieldKey="latitude"
              value={formData.latitude.code}
              disabled
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Longitude */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Longitude"
              fieldKey="longitude"
              value={formData.longitude.code}
              disabled
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Credit Limit */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Credit Limit"
              fieldKey="credit_limit"
              type="number"
              value={formData.credit_limit.code}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* Account Manager */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Account Manager"
              fieldKey="account_manager"
              value={formData.account_manager.code}
              onChange={handleFieldChange}
            />
          </Grid> */}
            </>
          )}
        </Grid>
        {/* ===== PHASE 2 · Business & Commercial (Extras) ===== */}
        {activeStep === 1 && (
        <Grid container columnSpacing={3} rowSpacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <SectionTitle>Extras</SectionTitle>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Population of the city"
              fieldKey="populationOfCity"
              value={formData.populationOfCity.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Regional Office"
              fieldKey="regionalOffice"
              value={formData.regionalOffice.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="No. of Years in Business (Tyre only)"
              fieldKey="noOfYearsBusiness"
              value={formData.noOfYearsBusiness.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Shop Status"
              fieldKey="shopStatus"
              value={formData.shopStatus.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Nearest JK Dealer (KM)"
              fieldKey="nearestJKDealer"
              value={formData.nearestJKDealer.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Nearest Steel Wheel (KM)"
              fieldKey="nearestSteelWheel"
              value={formData.nearestSteelWheel.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Competition Brand Shop (KM)"
              fieldKey="competitionBrandShop"
              value={formData.competitionBrandShop.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6} />
        </Grid>
        )}
        </Box>
        {/* Sticky Action Bar */}
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            mt: 3,
            // Full-bleed footer bar: cancel out the Paper padding so the
            // background spans edge-to-edge, then restore inner padding.
            mx: { xs: -2, md: -2.5 },
            px: { xs: 2, md: 2.5 },
            pt: 2,
            pb: 2,
            backgroundColor: "background.paper",
            borderTop: "1px solid",
            borderColor: "divider",
            zIndex: 2,
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{
              justifyContent: "space-between",
              alignItems: { xs: "stretch", sm: "center" },
            }}
          >
            {activeStep === 0 ? (
              <Button variant="outlined" size="large" onClick={handleCancel}>
                Cancel
              </Button>
            ) : (
              <Button
                variant="outlined"
                size="large"
                startIcon={<ArrowBackIcon />}
                onClick={handleBack}
              >
                Back
              </Button>
            )}
            {activeStep === 0 ? (
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleNext}
                sx={{ fontWeight: 700 }}
              >
                Next
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                size="large"
                disabled={disableSubmit || stageFlow.disabled}
                onClick={handleSubmit}
                sx={{ fontWeight: 700 }}
              >
                {stageFlow.label}
              </Button>
            )}
          </Stack>
        </Box>
      </SectionCard>

      {/* Preview + confirm-submit dialog */}
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        fullWidth
        maxWidth="lg"
      >
        <DealerOnboardPreview
          inDialog
          formData={formData}
          prospectData={prospectData}
          dealerId={dealerId}
          prospectId={prospectId}
          docPreviews={docPreviews}
          onBack={() => setPreviewOpen(false)}
          onSubmitted={() => {
            setPreviewOpen(false);
            history.push("/actyv-ai");
          }}
        />
      </Dialog>
    </Container>
  );
};

const DealerOnboardFormData = () => {
  return (
    <AccessController roles={["RO", "ZO", "ADMIN", "AO"]}>
      <DashGridL2 Top={TopBar} Main={DealerOnboardForm} />
      <Toaster />
    </AccessController>
  );
};

export default DealerOnboardFormData;





